import { Outlet } from 'react-router-dom';
import { AnimatedBackground } from '../../components/background/AnimatedBackground';
import { BackOfficeNavbar } from '../../components/navigation/BackOfficeNavbar';

export function BackOfficeLayout() {
  return (
    <div className="backoffice-shell relative isolate">
      <AnimatedBackground opacity={0.55} scale={1.7} speed={0.85} />
      <BackOfficeNavbar />
      {/* overflow-visible (not hidden) so the KPI status orbs, which float just
          outside the cards' top-right corner, aren't clipped. Height is still
          bounded by flex-auto + min-h-0, so pages keep owning their internal
          scroll; the shell's own overflow:hidden still contains everything. */}
      <div className="mt-xl flex-auto min-h-0 overflow-visible">
        <Outlet />
      </div>
    </div>
  );
}
